<div class="container-fluid h-100">
  <div class="row h-100 ">
    <div class="col-auto bg-white h-100 d-none d-lg-block">
      <Sidebar ref="sidebar"></Sidebar>
    </div>
    <div class="col bg-white h-100 m-0">
      <Navbar @toggle-sidebar="toggleSidebar"></Navbar>
      <div class="bg-gray px-4 py-1 h-100 scroll-container">
      <!-- <div class="bg-gray px-4 py-1 h-100"> -->
        <div class="card rounded-3 p-3 mb-2 bg-white rounded-5 shadow-sm mt-3 border-0">

          <div class="row mt-2 align-items-center">
            <!-- Question Input -->
            <div class="form-group col-sm-6 mb-1 my-3">
  <label class="text-secondary text-xs">
    Question<span class="text-danger">*</span>
  </label>
  <input type="text"
         class="form-control text-xxs rounded-5 p-2 bg-white"
         v-model="newQuestion.text"
         placeholder="Enter question text" />
  <small class="text-danger" v-if="errors.newQuestion?.text">{{ errors.newQuestion.text }}</small>
</div>


            <!-- Question Number Input -->
            <div class="form-group col-sm-6 mb-1 my-3">
  <label class="text-secondary text-xs">
    Question Number<span class="text-danger">*</span>
  </label>
  <input type="text"
         class="form-control text-xxs rounded-5 p-2 bg-white"
         v-model="newQuestion.question_number"
         placeholder="Eg. 1" />
  <small class="text-danger" v-if="errors.newQuestion?.question_number">{{ errors.newQuestion.question_number }}</small>
</div>


            <!-- Question Type Select -->
            <div class="form-group col-sm-6 mb-1 my-3">
  <label class="text-secondary text-xs">
    Type<span class="text-danger">*</span>
  </label>
  <select v-model="newQuestion.type" class="form-select text-xxs p-2 rounded-5">
    <option value="" disabled selected>Select</option>
    <option v-for="type in question_types" :key="type.id" :value="type.id">
      {{ type.question_type }}
    </option>
  </select>
  <small class="text-danger" v-if="errors.newQuestion?.type">{{ errors.newQuestion.type }}</small>

              <!-- Options for Multiple Choice -->
              <div v-if="newQuestion.type && question_types.find(t => t.id === newQuestion.type)?.question_type === 'multiple_choice'" v-for="(option, index) in newQuestion.options" :key="option.id" class="d-flex align-items-center mb-2">
                <input type="text"
                       class="form-control text-xxs rounded-5 p-2 me-2"
                       v-model="option.text"
                       placeholder="Enter option text" />
                <button class="btn btn-danger btn-sm text-xs" type="button" @click="removeOption(index)">
                  <i class="bi bi-trash"></i>
                </button>
              </div>

              <!-- Options for Selection -->
              <div v-if="newQuestion.type && question_types.find(t => t.id === newQuestion.type)?.question_type === 'selection'" v-for="(option, index) in newQuestion.options" :key="option.id" class="d-flex align-items-center mb-2">
                <input type="text"
                       class="form-control text-xxs rounded-5 p-2 me-2"
                       v-model="option.text"
                       placeholder="Enter option text" />
                <button class="btn btn-danger btn-sm text-xs" type="button" @click="removeOption(index)">
                  <i class="bi bi-trash"></i>
                </button>
              </div>

              <!-- Options for Checkbox -->
              <div v-if="newQuestion.type && question_types.find(t => t.id === newQuestion.type)?.question_type === 'checkbox'" v-for="(option, index) in newQuestion.options" :key="option.id" class="d-flex align-items-center mb-2">
                <input type="text"
                       class="form-control text-xxs rounded-5 p-2 me-2"
                       v-model="option.text"
                       placeholder="Enter option text" />
                <button class="btn btn-danger btn-sm text-xs" type="button" @click="removeOption(index)">
                  <i class="bi bi-trash"></i>
                </button>
              </div>

              <!-- Add Option Button -->
              <div v-if="newQuestion.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === newQuestion.type)?.question_type)">
                <button class="btn btn-warning text-white mt-3 text-xs rounded-5 shadow-lg fw-500" type="button" @click="addOption">
                  <i class="bi bi-plus"></i> Add Question Option
                </button>
              </div>
            </div>

            <div class="form-group col-sm-6 mb-1 my-3">
  <label class="text-secondary text-xs">Is the question mandatory?</label>
  <select v-model="newQuestion.is_mandatory" class="form-select text-xxs p-2 rounded-5">
    <option :value="true">Yes</option>
    <option :value="false">No</option>
  </select>
</div>


          </div>
          <div class="card-footer border-0 bg-white">
            <button type="button" class="btn btn-secondary text-white text-xxs rounded-3 shadow-lg fw-500 float-end" @click="createQuestion()">
              Save
            </button>
          </div>
        
      </div>
      <!-- Questions Table -->
      <div class="card border-0 p-3 rounded-5 shadow-sm mb-3 bg-white">
        <div class="card-header bg-transparent border-0">
          <h5 class="text-secondary">Questions List</h5>
          <button
          v-if="is_unassigning && is_ready_to_unassign"
          @click="submit_unassign"
          type="button"
          class="btn btn-success text-white text-xxs rounded-3 shadow-sm fw-500"
        >
          Save
        </button>
        </div>
        <div class="table-responsive">
 <table class="table table-striped text-xs mt-3">
          <thead class="bg-dark text-white text-xxs">
            <tr>
              <th scope="col">
                <input 
                  type="checkbox" 
                  @change="toggleSelectAll($event)" 
                  :checked="allSelected"
                />
              </th>
              <th scope="col">#No</th>
              <th scope="col">Question</th>
              <th scope="col">Question Type</th>
              <th scope="col">Options</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody class="text-black">
            <tr 
              v-for="(question, index) in questions" 
              :key="question.id" 
              class="border-section text-xs"
            >
              <td>
                <input 
                  type="checkbox" 
                  :value="question.id" 
                  v-model="selectedQuestions"
                />
              </td>
              <th scope="row">{{ index + 1 }}</th>
              <td>{{ question.question }}</td>
              <td>{{ question.question_type.question_type }}</td>
              <td>
                <ul>
                  <li v-for="(opt, index) in question.options" :key="index">{{ opt.option }}</li>
                </ul>
              </td>

              <td>
                <button
                  class="btn btn-primary text-xxs rounded-3 mx-1 btn-sm shadow"
                  @click="openEditModal(question)">
                  <i class="bi bi-pencil-square"></i> Edit
              </button>
                <button
                  class="btn btn-danger text-xxs rounded-3 mx-1 btn-sm shadow"
                  @click="delete_question(question.id)"
                >
                  <i class="bi bi-trash"></i> Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      
      </div>

      </div>
    </div>
  </div>
</div>

<!-- Edit Question Modal -->
<div class="modal fade" id="edit_question_modal" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">

      <div class="card rounded-3 p-3 mb-2 bg-white rounded-5 shadow-sm mt-3 border-0">
        <div class="row mt-2 align-items-center">
          <!-- Question Input -->
          <div class="form-group col-sm-6 mb-1 my-3">
            <label class="text-secondary text-xs">Question<span class="text-danger">*</span></label>
            <input type="text" class="form-control text-xxs rounded-5 p-2 bg-white" v-model="editQuestion.text" placeholder="Enter question text" />
          </div>

          <!-- Question Number Input -->
          <div class="form-group col-sm-6 mb-1 my-3">
            <label class="text-secondary text-xs">Question Number<span class="text-danger">*</span></label>
            <input type="text" class="form-control text-xxs rounded-5 p-2 bg-white" v-model="editQuestion.question_number" placeholder="Eg. 1" />
          </div>

          <!-- Question Type Select -->
          <div class="form-group col-sm-6 mb-1 my-3">
            <label class="text-secondary text-xs">Type<span class="text-danger">*</span></label>
            <select v-model="editQuestion.type" class="form-select text-xxs p-2 rounded-5">
              <option value="" disabled>Select</option>
              <option v-for="type in question_types" :key="type.id" :value="type.id">
                {{ type.question_type }}
              </option>
            </select>

            <!-- Options -->
            <div v-for="(option, index) in editQuestion.options"
                 :key="index"
                 v-if="editQuestion.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === editQuestion.type)?.question_type)"
                 class="d-flex align-items-center mb-2 mt-2">
              <input type="text"
                     class="form-control text-xxs rounded-5 p-2 me-2"
                     v-model="option.text"
                     placeholder="Enter option text" />
              <button class="btn btn-danger btn-sm text-xs" type="button" @click="editQuestion.options.splice(index, 1)">
                <i class="bi bi-trash"></i>
              </button>
            </div>

            <div v-if="editQuestion.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === editQuestion.type)?.question_type)">
              <button class="btn btn-warning text-white mt-3 text-xs rounded-5 shadow-lg fw-500" type="button" @click="editQuestion.options.push({ text: '' })">
                <i class="bi bi-plus"></i> Add Question Option
              </button>
            </div>
          </div>

          <!-- Mandatory -->
          <div class="form-group col-sm-6 mb-1 my-3">
            <label class="text-secondary text-xs">Is the question mandatory?</label>
            <select v-model="editQuestion.is_mandatory" class="form-select text-xxs p-2 rounded-5">
              <option :value="true">Yes</option>
              <option :value="false">No</option>
            </select>
          </div>
        </div>

        <div class="card-footer border-0 bg-white">
          <button
            type="button"
            class="btn btn-success text-white text-xxs rounded-3 shadow-lg fw-500 float-end"
            @click="submitEditQuestion">
            <i class="bi bi-pencil me-1"></i> Update
          </button>
        </div>
      </div>

    </div>
  </div>
</div>

